/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const PAGE_INITIALIZATION_START = 'mbp-checkout/PAGE_INITIALIZATION_START';
export const PAGE_INITIALIZATION_COMPLETED = 'mbp-checkout/PAGE_INITIALIZATION_COMPLETED';
